// client/src/components/pages/LexiStar/FleetTargets/chartTheme.ts (ST-00247 / ST-00248)
//
// The chart chrome of the Fleet & targets visuals, through the theme's colour variables (each
// flips with data-theme; src/index.css): solid hairline grid and axes one step off the surface,
// muted tick text, the tooltip on the raised surface. Series colours come from fleetLogic
// (the shared asset status palette and the brand teal); text never wears a series colour.

const tw = (name: string) => `rgb(var(--tw-${name}))`;

export const GRID = tw('slate-200');
export const AXIS = tw('slate-300');
export const TICK = { fontSize: 11, fill: tw('slate-500') };
/** The target line: ink, so it reads as the reference against the coloured bars. */
export const TARGET_LINE = tw('slate-700');
export const ACTUAL_BAR = 'rgb(var(--tw-primary-600))';

export const TOOLTIP_STYLE = {
  background: 'var(--surface-raised)',
  border: '1px solid var(--border)',
  borderRadius: 8,
  color: 'var(--text)',
  fontSize: 12,
};
export const TOOLTIP_LABEL = { color: 'var(--text-strong)', fontWeight: 600 };
/** The hover band behind a bar group: a ghost wash, never a block. */
export const CURSOR = { fill: tw('slate-100') };

/** Bars at most 24 px thick (marks spec), here thinner: two per truck. */
export const BAR_SIZE = 10;
/** Round data end (4 px), square at the baseline, for horizontal bars. */
export const RADIUS_H: [number, number, number, number] = [0, 4, 4, 0];
/** Round data end (4 px), square at the baseline, for columns. */
export const RADIUS_V: [number, number, number, number] = [4, 4, 0, 0];
